import React from 'react';
import { useNavigate } from 'react-router-dom';
import logouni from '../img/imagotipo-azul.png';

const Principal = () => {
  const navigate = useNavigate();  

  const handleStartQuiz = () => {
    navigate('/home'); 
  };

  return (
    <main>
      <div className="logotipo">
        <img src={logouni} alt="El Universal" />
      </div>

      <div className="centrado">
        <div className="introduccion">
          <p className="quiz">Quiz</p>
          <p className="titulo-quiz">
            ¿<span style={{ color: '#2A3378' }}>Kamala Harris</span> o{' '}
            <span style={{ color: '#EE212D' }}>Donald Trump</span>, qué tanto sabes de los candidatos?
          </p>
        </div>

        <div className="main-fondo" style={{ backgroundImage: 'url("static/media/main-1920.d78a9de218ff4f8271f4.png")' }}>
          <div className="instrucciones">
            <p className="descripcion-quiz">
              Estados Unidos tendrá elecciones presidenciales el 5 de noviembre, en las que la vicepresidenta demócrata
              Kamala Harris se medirá con el republicano Donald Trump.
            </p>
            <p className="cta">
              <span style={{ color: '#2A3378' }}>¿Qué tanto sabes de ellos y sus propuestas?</span> Contesta de quién
              estamos hablando y ¡averígualo!
            </p>
            <button className="boton-cta" onClick={handleStartQuiz}>
              <span className="i-boton">¡Iniciar quiz!</span>
            </button>
          </div>
        </div>
      </div>

    </main>
  );
};

export default Principal;
